var map = {
	"./en/help-center/help-center": [
		"2071",
		9,
		"chunk-2d0b168e"
	],
	"./en/help-center/help-center.js": [
		"2071",
		9,
		"chunk-2d0b168e"
	],
	"./en/legal-policies/legal-policies": [
		"3839",
		7,
		"chunk-2d0ba881"
	],
	"./en/legal-policies/legal-policies.js": [
		"3839",
		7,
		"chunk-2d0ba881"
	],
	"./en/special-legal-policies/special-legal-policies": [
		"d408",
		7,
		"chunk-2d21df4e"
	],
	"./en/special-legal-policies/special-legal-policies.js": [
		"d408",
		7,
		"chunk-2d21df4e"
	],
	"./km/help-center/help-center": [
		"d538",
		9,
		"chunk-2d21e36c"
	],
	"./km/help-center/help-center.js": [
		"d538",
		9,
		"chunk-2d21e36c"
	],
	"./km/legal-policies/legal-policies": [
		"5c1a",
		7,
		"chunk-2d0d3294"
	],
	"./km/legal-policies/legal-policies.js": [
		"5c1a",
		7,
		"chunk-2d0d3294"
	],
	"./km/special-legal-policies/special-legal-policies": [
		"79f6",
		7,
		"chunk-2d0d83e8"
	],
	"./km/special-legal-policies/special-legal-policies.js": [
		"79f6",
		7,
		"chunk-2d0d83e8"
	],
	"./language": [
		"0ffa",
		9
	],
	"./language.js": [
		"0ffa",
		9
	],
	"./zh/help-center/help-center": [
		"dbc8",
		9,
		"chunk-2d229229"
	],
	"./zh/help-center/help-center.js": [
		"dbc8",
		9,
		"chunk-2d229229"
	],
	"./zh/legal-policies/legal-policies": [
		"3dc0",
		7,
		"chunk-2d0c5374"
	],
	"./zh/legal-policies/legal-policies.js": [
		"3dc0",
		7,
		"chunk-2d0c5374"
	],
	"./zh/special-legal-policies/special-legal-policies": [
		"7d52",
		7,
		"chunk-2d0e1f60"
	],
	"./zh/special-legal-policies/special-legal-policies.js": [
		"7d52",
		7,
		"chunk-2d0e1f60"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a92b";
module.exports = webpackAsyncContext;